var _popoverPositions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Div } from '@kizi/core-components';
import debounce from 'lodash/debounce';
import * as React from 'react';
import { Portal } from 'react-portal';
import useOnClickOutside from 'use-onclickoutside';
export var PopoverPosition;

(function (PopoverPosition) {
  PopoverPosition["Top"] = "Top";
  PopoverPosition["Right"] = "Right";
  PopoverPosition["Bottom"] = "Bottom";
  PopoverPosition["Left"] = "Left";
})(PopoverPosition || (PopoverPosition = {}));

export var popoverPositions = (_popoverPositions = {}, _defineProperty(_popoverPositions, PopoverPosition.Top, {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'center'
  },
  transformOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  }
}), _defineProperty(_popoverPositions, PopoverPosition.Right, {
  anchorOrigin: {
    vertical: 'center',
    horizontal: 'right'
  },
  transformOrigin: {
    vertical: 'center',
    horizontal: 'left'
  }
}), _defineProperty(_popoverPositions, PopoverPosition.Bottom, {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center'
  }
}), _defineProperty(_popoverPositions, PopoverPosition.Left, {
  anchorOrigin: {
    vertical: 'center',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'center',
    horizontal: 'right'
  }
}), _popoverPositions);
var defaultProps = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  }
};
export function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
export function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}
export function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return "".concat(n, "px");
  }).join(' ');
} // export const Popover = React.forwardRef<HTMLDivElement, PopoverProps>(
// function Popover(props, ref) {

export function Popover(props) {
  var children = props.children,
      open = props.open,
      anchorEl = props.anchorEl,
      anchorPosition = props.anchorPosition,
      anchorOrigin = props.anchorOrigin,
      transformOrigin = props.transformOrigin,
      onClose = props.onClose;
  var popoverRef = React.useRef(null);
  var getAnchorOffset = React.useCallback(function () {
    if (!anchorEl) {
      return anchorPosition;
    }

    var anchorRect = anchorEl.getBoundingClientRect();
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorPosition, anchorOrigin.horizontal, anchorOrigin.vertical]);
  var getTransformOrigin = React.useCallback(function (elemRect) {
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical),
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = React.useCallback(function (element) {
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    };
    var elemTransformOrigin = getTransformOrigin(elemRect);
    var anchorOffset = getAnchorOffset();
    var top = anchorOffset ? anchorOffset.top - elemTransformOrigin.vertical : 0;
    var left = anchorOffset ? anchorOffset.left - elemTransformOrigin.horizontal : 0;
    return {
      top: "".concat(Math.round(top), "px"),
      left: "".concat(Math.round(left), "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [getTransformOrigin, getAnchorOffset]);
  var setPositioningStyles = React.useCallback(function () {
    var element = popoverRef.current;

    if (!element) {
      return;
    }

    var positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);
  React.useEffect(function () {
    if (open) {
      setPositioningStyles();
    }
  });
  useOnClickOutside(popoverRef, function () {
    if (onClose) {
      onClose();
    }
  });
  React.useEffect(function () {
    if (!open) {
      return undefined;
    }

    var handleResize = debounce(function () {
      setPositioningStyles();
    }, 60);
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [anchorEl, open, setPositioningStyles]);

  if (!open) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Div, {
    position: "absolute",
    display: "inline-block",
    ref: popoverRef
  }, children));
} // );

Popover.defaultProps = defaultProps;